import { createContext, useContext, useState, type ReactNode } from 'react';
import { buildConfig } from '../config/buildConfig';
import { useAuth } from '../auth/AuthContext';
import { createHttpClient, type HttpClient } from './httpClient';

const ApiContext = createContext<HttpClient | undefined>(undefined);

export function ApiProvider({ children }: { children: ReactNode }) {
  const { getAccessToken } = useAuth();
  const [client] = useState(() => createHttpClient(buildConfig, getAccessToken));

  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): HttpClient {
  const client = useContext(ApiContext);
  if (!client) {
    throw new Error('useApi must be used within an ApiProvider.');
  }

  return client;
}
